export default __webpack_public_path__ + "static/textFilter-d7e6455bea7339e0da38fa8370bb5883.gif";